import React, { useEffect, useState } from "react";
import { BarContainer, Label, ProgressBar } from "./styles";

type CountdownBarProps = {
  expiration: string;
  start?: string;
};

const CountdownBar: React.FC<CountdownBarProps> = ({ expiration, start }) => {
  const [progress, setProgress] = useState(100);
  const [remaining, setRemaining] = useState(0);
  const [expired, setExpired] = useState(false);

  useEffect(() => {
    const target = new Date(expiration).getTime();

    let startMs = Date.now();
    if (start) {
      const parsedStart = new Date(start);
      if (!isNaN(parsedStart.getTime())) {
        startMs = parsedStart.getTime();
      }
    }

    const totalMs = target - startMs;

    const interval = setInterval(() => {
      const now = Date.now();
      const diff = target - now;

      if (diff <= 0) {
        setProgress(0);
        setRemaining(0);
        setExpired(true);
        clearInterval(interval);
        return;
      }

      setRemaining(diff);
      setProgress((diff / totalMs) * 100);
    }, 1000);

    return () => clearInterval(interval);
  }, [expiration, start]);

  const format = (ms: number) => {
    const h = Math.floor(ms / (1000 * 60 * 60));
    const m = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));
    const s = Math.floor((ms % (1000 * 60)) / 1000);
    return `${String(h).padStart(2, "0")}:${String(m).padStart(
      2,
      "0"
    )}:${String(s).padStart(2, "0")}`;
  };

  return (
    <div>
      {!expired && <Label>tempo restante</Label>}
      <BarContainer>
        <ProgressBar width={progress} expired={expired} />
      </BarContainer>
      <Label>
        {expired ? "Tempo expirado. Pagamento feito? Fique tranquilo, estamos confirmando." : format(remaining)}
      </Label>
    </div>
  );
};

export default CountdownBar;